import { gql } from "@apollo/client";

export const VIEWER_LEADERBOARD_DETAILS_FRAGMENT = gql`
  fragment ViewerLeaderboardDetails on Campaign {
    leaderboardDetails {
      campaign {
        color
        secondaryColor
        images {
          verifiedBadge
          campaign
        }
        promotionalCampaignClip {
          _id
        }
      }
      viewerContestant {
        user {
          avatar
          _id
          username
        }
        points
        rank
        clipsCreated
        verified
      }
    }
  }
`;

export const LEADERBOARD_DETAILS_FRAGMENT = gql`
  fragment LeaderboardDetails on Campaign {
    leaderboardDetails {
      campaign {
        color
        secondaryColor
        slug
        images {
          verifiedBadge
          campaign
        }
        promotionalCampaignClip {
          _id
        }
        endsAt
      }
      viewerContestant {
        user {
          avatar
          _id
          username
        }
        points
        rank
        clipsCreated
        verified
      }
      topTenContestants {
        user {
          avatar
          _id
          username
          userGroup {
            type
          }
          rank
        }
        points
        rank
        clipsCreated
        verified
      }
    }
  }
`;

export const CAMPAIGN_IMAGES_FRAGMENT = gql`
  fragment CampaignImages on Campaign {
    images {
      campaign
      carouselBackground
      promo
      promoCodeBackground
      verifiedBadge
    }
  }
`;

export const STEP_IMAGES_FRAGMENT = gql`
  fragment StepImages on CampaignStep {
    images {
      promo
      completionBadge
      promoCodeBackground
    }
  }
`;

export const CAMPAIGN_STEPS_FRAGMENT = gql`
  fragment CampaignSteps on Campaign {
    steps {
      stepId
      header
      body
      completed
      modalToOpen
      linkToOpen
      pointsAwarded
      montageCreditsAwarded
      promoCodeText
      buttonText
      urlPrompt {
        allowedDomains
        exampleUrl
      }
      ...StepImages
    }
  }
  ${STEP_IMAGES_FRAGMENT}
`;

export const CAMPAIGN_PRIZES_FRAGMENT = gql`
  fragment CampaignPrizes on Campaign {
    prizes {
      heading
      body
      image
      sectionLabel
    }
  }
`;

export const CAMPAIGN_CONTENT_RULES_FRAGMENT = gql`
  fragment CampaignContentRules on Campaign {
    contentRules {
      heading
      body
    }
  }
`;

export const CAMPAIGN_SIGNATURE_FRAGMENT = gql`
  fragment CampaignSignature on Campaign {
    signature {
      styleName
      themeName
    }
  }
`;

export const GET_CAMPAIGN = gql`
  query GetCampaign($slug: String!) {
    campaign(slug: $slug) {
      id
      _id
      slug
      endsAt
      games
      color
      secondaryColor
      creatorCards
      campaignName
      partnerName
      ...CampaignImages
      ...CampaignSteps
      promotionalCampaignClip {
        _id
      }
      ...CampaignContentRules
      ...CampaignPrizes
      ...LeaderboardDetails
      ...CampaignSignature
    }
  }
  ${CAMPAIGN_SIGNATURE_FRAGMENT}
  ${CAMPAIGN_IMAGES_FRAGMENT}
  ${CAMPAIGN_STEPS_FRAGMENT}
  ${CAMPAIGN_CONTENT_RULES_FRAGMENT}
  ${CAMPAIGN_PRIZES_FRAGMENT}
  ${LEADERBOARD_DETAILS_FRAGMENT}
`;

export const GET_VIEWER_LEADERBOARD_DETAILS = gql`
  query GetLeaderboardDetails($slug: String!) {
    campaign(slug: $slug) {
      ...ViewerLeaderboardDetails
    }
  }
  ${VIEWER_LEADERBOARD_DETAILS_FRAGMENT}
`;

export const SUBMIT_STEP_URL = gql`
  mutation SubmitStepUrl(
    $stepId: String!
    $url: String!
    $campaignSlug: String!
  ) {
    submitStepUrl(stepId: $stepId, url: $url, campaignSlug: $campaignSlug) {
      success
      message
    }
  }
`;
